import Styles      from "./home.module.css";
import homeSet     from "../assets/Empty-bro.png";
import searchSet   from "../assets/curiosity search-bro.png";
import faveSet     from "../assets/To do list-bro.png";
import profileSet  from "../assets/Resume-bro.png";
import { Element } from "./home_comps";
import { useEffect, useState } from "react";
import { getAllItem  } from "../api"
export const HomeBody = ( props ) => {
    const { page, setViewWindow, setViewRequest, setItemId, itemId, viewWindow, viewRequest } = props;
    const { HomeBody } = Styles;
    return (
        <main className = { HomeBody }>
            {/*=====HomePage=====*/}
            { page === "home"     &&
                <HomePage 
		    setItemId      = { setItemId      }
		    itemId         = { itemId         }
                    setViewWindow  = { setViewWindow  } 
                    setViewRequest = { setViewRequest }
		    viewWindow     = { viewWindow     }
		    viewRequest    = { viewRequest    }
                />
            }
            {/*=====SearchPage=====*/}
            { page === "search"   && <SearchPage />   }
            {/*=====FavoritePage=====*/}
            { page === "favorite" && <FavoritePage
		    setItemId      = { setItemId      }
		    itemId         = { itemId         }
		    setViewWindow  = { setViewWindow  }
		    setViewRequest = { setViewRequest }
		    viewWindow     = { viewWindow     }
		    viewRequest    = { viewRequest    }
	    /> }
            {/*=====ProfilePage=====*/}
            { page === "profile"  && <ProfilePage />  }
            
        </main>
    );
};
//defualt page 
const DefaultSet      = ( props ) => {
    const { img, label } = props;
    const { DefaultSet } = Styles;
    return (
        <div className = { DefaultSet }>
            <img src={ img } alt={ label } loading="lazy"/>
            <h3>{ label }</h3>
        </div>
    );
};
//home page
const HomePage     = ( props ) => {
    const { setViewWindow, setViewRequest, setItemId, itemId, viewWindow, viewRequest } = props;
    const { HomePage, } = Styles;
    const [ list, setList ] = useState([]);

    useEffect(_=>{	
        getAllItem()
                .then(data => setList(data.reverse()))
                .catch(error => alert("Error fetching items:", error));
    }, [viewWindow, viewRequest]);
    
    return (
        <div className = { HomePage }>
            { list.length == 0 && <DefaultSet img = { homeSet } label = { "لاتوجد منتجات بعد" }/> }
            { list.length != 0 && list.map((value, key) => {
                const { id = "", album = "", description = "", mainImg = "", title = "", price = "" } = value;
                return(
                    <Element
			id             = { id             }
                        title          = { title          }
                        label          = { description    }
                        img            = { mainImg        }
                        price          = { price          }
			album          = { album          }
                        key            = { key            }
                        setViewWindow  = { setViewWindow  }
                        setViewRequest = { setViewRequest }
			setItemId      = { setItemId      }
			itemId         = { itemId         }
		        viewWindow     = { viewWindow     }
			viewRequest    = { viewRequest    }

                    />
                );
            })}
        </div>
    );
};
const SearchPage   = ( props ) => {
    const { } = props;
    const { HomePage } = Styles;
    return (
        <div className = { HomePage }>
            <DefaultSet img = { searchSet } label = "ميزة البحث غير متوفرة حاليا"/>
        </div>
    );
};
const FavoritePage = ( props ) => {
    const { setViewWindow, setViewRequest, setItemId, itemId, viewWindow, viewRequest } = props;
    const { HomePage } = Styles;
    const [ list, setList ] = useState([]);
    const [ favor, setFavor ] = useState([]);
    useEffect(_=>{
        getAllItem()
                .then(data => setList(data.reverse()))
                .catch(error => alert("Error fetching items:", error));
	if(localStorage.getItem("favorites")){
	    setFavor(JSON.parse(localStorage.getItem("favorites")));
	}
    }, [viewWindow, viewRequest]);
    return (
        <div className = { HomePage }>
	    { favor.length === 0 && <DefaultSet img = { faveSet } label = "قائمة المفضلات فارغة"/> }
	    { favor.length !== 0 && list.map((value , key) => {
		    const { id = "", album = "", description = "", mainImg = "", title = "", price = "" } = value;
		    return favor.includes(id) &&  <Element
                        id             = { id             }
                        title          = { title          }
                        label          = { description    }
                        img            = { mainImg        }
                        price          = { price          }
                        album          = { album          }
                        key            = { key            }
                        setViewWindow  = { setViewWindow  }
                        setViewRequest = { setViewRequest }
                        setItemId      = { setItemId      }
                        itemId         = { itemId         }
                        viewWindow     = { viewWindow     }
                        viewRequest    = { viewRequest    }
            />})}
        </div>
    );
};
const ProfilePage  = ( props ) => {
    const { } = props;
    const { HomePage } = Styles;
    return (
        <div className = { HomePage }>
            <DefaultSet img = { profileSet } label = "هذه الميزة غير متوفرة حاليا"/>
        </div>
    );
};
